import styled, { keyframes } from "styled-components";
import { bodyTextBold, bodyTextRegular, breakpoint } from "./style";

const HeaderElement = styled.header`
    display: flex;
    flex-direction: column;
    width: 100%;
    position: relative;
    margin-bottom: 50px;

`;


const rotateAnimation = keyframes`
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
`;


const HeaderBackgroundCycle = styled.div`
    position: absolute;
    background-image: url('./assets/design/proxies-cycle-only.png');
    background-origin: center center;
    background-attachment: scroll;
    background-size: 100%;
    width: 50vw;
    height: 50vw;
    z-index: -99999;
    overflow: hidden;
    content: "";
    opacity: 0.2;

    animation: ${rotateAnimation};
    animation-iteration-count: infinite, 1;
    animation-fill-mode: forwards;
    animation-timing-function: linear;

    &.top-left {
        top: -22vw;
        left: -22vw;
        animation-duration: 40s, 0.5s;
        animation-delay: 0s, 0.25s;
    }

    &.top-left-large {
        top: -28.77vw;
        left: -27.77vw;
        width: 66.67vw;
        height: 66.67vw;
        animation-duration: 70s, 0.5s;
        animation-delay: 0s, 1s;
    }

    &.bottom-right {
        top: 22vw;
        right: -22vw;
        animation-duration: 40s, 0.5s;
        animation-delay: 0s, 0.5s;

    }

    &.bottom-right-large {
        top: 13.67vw;
        right: -30.55vw;
        width: 66.67vw;
        height: 66.67vw;
        animation-duration: 70s, 0.5s;
        animation-delay: 0s, 0.75s;
    }
`;

const HeaderTitleContainer = styled.div`
    margin-top: 50px;
    padding: 0px 50px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    // background: linear-gradient(0deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.9) 25%, rgba(255,255,255,0.9) 75%, rgba(255,255,255,0) 100%);

    @media ${breakpoint.phone} {
        padding: 100px 40px;
        background: none;
    }
`;



const HeaderTitle = styled.h1`
    font-size: 40pt;
    font-weight: 500;
    margin: 0px;
    margin-bottom: 20px;
    text-transform: uppercase;
    font-family: "Tenor Sans", sans-serif;
    font-weight: 400;
    font-style: normal;
    text-shadow: 2px 2px 3px #C0C0C0;


    @media ${breakpoint.tablet} {
        font-size: 30pt;
    }

    @media ${breakpoint.phone} {
        font-size: 20pt;
    }
    
`;

const HeaderSubtitle = styled.h2`
    ${bodyTextBold};
    font-size: 1.3rem;
    line-height: 1.6rem;
    margin: 0px;






    `;

const ByLine = styled.h2`
    ${bodyTextRegular};
    font-size: 1.3rem;
    line-height: 1.6rem;
    margin: 20px 0px 0px 0px;



`;

const HeaderBackgroundContainer = styled.div`
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100vh;
    z-index: -10000;
    pointer-events: none;
    // overflow: hidden;


`;


export const HeaderBackground = () => {
    return <HeaderBackgroundContainer>
        <HeaderBackgroundCycle className="top-left-large"></HeaderBackgroundCycle>
        <HeaderBackgroundCycle className="top-left"></HeaderBackgroundCycle>
        <HeaderBackgroundCycle className="bottom-right"></HeaderBackgroundCycle>
        <HeaderBackgroundCycle className="bottom-right-large"></HeaderBackgroundCycle>
    </HeaderBackgroundContainer>;

}

const Header = () => {

    return <HeaderElement>
        <HeaderTitleContainer>
            <HeaderTitle>Deconstructing Proxies</HeaderTitle>
            <HeaderSubtitle>Research in progress on interactions between
                dance, technology, and design</HeaderSubtitle>
            <ByLine>Ilya Vidrin, <i>Artistic Director</i><br />
                Steven Geofrey, <i>Design and Data Visualization</i><br />
                Design Research Week 2025</ByLine>

        </HeaderTitleContainer>

    </HeaderElement>

};

export default Header;